import { Component, ElementRef, OnInit } from '@angular/core';

interface MediaBlockViewModel {
    ImageUrl?: string;
    Tag?: string;
    Date?: string;
    Headline?: string;
    Summary?: string;
    LinkUrl?: string;
}

@Component({
    selector: 'media-block',
    templateUrl: './media-block.component.html',
    styles: [`
        .swapa-media-block-image {
            object-fit: cover;
        }

        .swapa-media-block-image-wrapper {
            margin-bottom: 12px;
        }

        .swapa-media-block-meta + .swapa-media-block-headline {
            margin-top: 12px;
        }

        .swapa-media-block-headline + .swapa-media-block-summary {
            margin-top: 8px;
        }

        .swapa-media-block-headline + .swapa-media-block-date {
            margin-top: 6px;
        }

        /* Space only between summary and date, so a card ending in its summary has no trailing gap. */
        .swapa-media-block-summary + .swapa-media-block-date {
            margin-top: 8px;
        }

        .swapa-media-block-meta,
        .swapa-media-block-date {
            font-size: 0.875rem;
            line-height: 1.1;
        }

        .swapa-media-block-tag,
        .swapa-media-block-date {
            color: #808080;
        }

        .swapa-media-block-headline {
            color: #414042;
            font-family: 'URW DIN Condensed', 'Nimbus Sans', sans-serif;
            font-size: 1.625rem;
            line-height: 1.75rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow-wrap: anywhere;
        }

        .swapa-media-block-summary {
            font-family: "Nimbus Sans", Arial, sans-serif;
            font-weight: 400;
            font-size: 1rem;
            line-height: 1.25rem;
            color: #5a5a5a;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow-wrap: anywhere;
        }
    `],
})
export class MediaBlockComponent implements OnInit {
    public config: MediaBlockViewModel | null = null;

    constructor(private host: ElementRef<HTMLElement>) { }

    ngOnInit(): void {
        // The server sends the block's data as JSON in an attribute; attributes survive Angular taking over the host element.
        const json = this.host.nativeElement.getAttribute('config');
        if (!json) {
            return;
        }

        try {
            this.config = JSON.parse(json) as MediaBlockViewModel;
        } catch {
            this.config = null;
        }
    }
}
